import { AxiosResponse } from 'axios'
import axios from '@/services/axios'
import type {
  PromotionInterface,
  PromotionGroupCreatePayload,
  PromotionGroupInterface,
  PromotionGroupUpdatePayload,
  PromotionUpsertPayload,
} from '@/models/shop/Promotion.types'

export default abstract class PromotionsApi {
  public static route = process.env.VUE_APP_SHOP_V2_BASE_URI
  public static entity = 'promotions'

  public static async list(
    arenaId: string,
    params: object = {},
  ): Promise<
    AxiosResponse<{
      data: PromotionInterface[]
      metadata: { count: number; page: number; size: number; sort: string }
    }>
  > {
    const url = `${this.route}/arenas/${arenaId}/${this.entity}`
    return await axios.get(url, { params })
  }

  public static async create(
    arenaId: string,
    data: PromotionUpsertPayload,
  ): Promise<AxiosResponse<PromotionInterface>> {
    const url = `${this.route}/arenas/${arenaId}/${this.entity}`
    return await axios.post(url, data)
  }

  public static async get(
    arenaId: string,
    id: string,
  ): Promise<AxiosResponse<PromotionInterface>> {
    const url = `${this.route}/arenas/${arenaId}/${this.entity}/${id}`
    return await axios.get(url)
  }

  public static async update(
    arenaId: string,
    id: string,
    data: PromotionUpsertPayload,
  ): Promise<AxiosResponse<PromotionInterface>> {
    const url = `${this.route}/arenas/${arenaId}/${this.entity}/${id}`
    return await axios.patch(url, data)
  }

  public static async delete(
    arenaId: string,
    id: string,
  ): Promise<AxiosResponse<void>> {
    const url = `${this.route}/arenas/${arenaId}/${this.entity}/${id}`
    return await axios.delete(url)
  }

  public static async createPromotionGroup(
    arenaId: string,
    id: string,
    data: PromotionGroupCreatePayload,
  ): Promise<AxiosResponse<PromotionGroupInterface>> {
    const url = `${this.route}/arenas/${arenaId}/${this.entity}/${id}/groups`
    return await axios.post(url, data)
  }

  public static async updatePromotionGroup(
    arenaId: string,
    id: string,
    groupId: string,
    data: PromotionGroupUpdatePayload,
  ): Promise<AxiosResponse<PromotionGroupInterface>> {
    const url = `${this.route}/arenas/${arenaId}/${this.entity}/${id}/groups/${groupId}`
    return await axios.patch(url, data)
  }

  public static async deletePromotionGroup(
    arenaId: string,
    id: string,
    groupId: string,
  ): Promise<AxiosResponse<void>> {
    const url = `${this.route}/arenas/${arenaId}/${this.entity}/${id}/groups/${groupId}`
    return await axios.delete(url)
  }

  public static async createPromotionGroupVariant(
    arenaId: string,
    id: string,
    groupId: string,
    data: { arena_variant_id: string },
  ): Promise<AxiosResponse> {
    const url = `${this.route}/arenas/${arenaId}/${this.entity}/${id}/groups/${groupId}/variants`
    return await axios.post(url, data)
  }

  public static async deletePromotionGroupVariant(
    arenaId: string,
    id: string,
    groupId: string,
    variantId: string,
  ): Promise<AxiosResponse<void>> {
    const url = `${this.route}/arenas/${arenaId}/${this.entity}/${id}/groups/${groupId}/variants/${variantId}`
    return await axios.delete(url)
  }
}
